export default __webpack_public_path__ + "static/media/ad_preview_display_top.da74e905.svg";